import React from 'react'
import { Button } from '@components/Basic/ButtonNbe'
import { useTranslation } from 'react-i18next'
import { BillingNoticeWrapper } from '@features/billing/BillingNotificationBox/styled'

interface AmountDueBoxProps {
  amount: number
  onPayClick: () => void
  isLoading: boolean
}

export const AmountDueBox: React.FC<AmountDueBoxProps> = ({ amount, onPayClick, isLoading }) => {
  const { t } = useTranslation()
  return (
    <BillingNoticeWrapper>
      <div>
        <h4>{t('billing.payment.amountDueTitle')}</h4>
        <p>
          {t('billing.payment.amountDueMessage', {
            amount: amount.toFixed(2),
          })}
        </p>
      </div>
      <Button
        type='button'
        $variant='action'
        $size='large'
        onClick={onPayClick}
        $loading={isLoading}
        disabled={isLoading}
      >
        {t('billing.payment.payNowCta')}
      </Button>
    </BillingNoticeWrapper>
  )
}
